import { createContext, useState, useContext } from "react";

export const RegisterContext = createContext();
export const RegisterContextSetState = createContext();

function RegisterContextProvider({ children }) {
  const [state, setState] = useState({
    phoneNumber: "",
    role: "",
    code: "",
    step: 1,
  });
  return (
    <RegisterContext.Provider value={state}>
      <RegisterContextSetState.Provider value={setState}>
        {children}
      </RegisterContextSetState.Provider>
    </RegisterContext.Provider>
  );
}

export const useRegisterState = () => {
  const registerState = useContext(RegisterContext);
  return registerState;
};
export const useRegisterSetState = () => {
  const registerSetState = useContext(RegisterContextSetState);
  return registerSetState;
};

export const useRegisterActions = () => {
  const setState = useRegisterSetState();
  const setPhoneNumberAction = (number) =>
    setState((prev) => ({
      ...prev,
      phoneNumber: number,
    }));
  const setCodeNumber = (code, password) =>
    setState((prev) => ({
      ...prev,
      code,
      password,
    }));

  const setStep = (step) =>
    setState((prev) => ({
      ...prev,
      step,
    }));
  return { setPhoneNumberAction, setCodeNumber, setStep };
};

export default RegisterContextProvider;
